import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import ApiMakerTable from "shared/api-maker-table"
import classNames from "classnames"
import ContactLink from "components/contacts/link"
import {Dialogue} from "models"
import DialogueLink from "components/dialogues/link"
import linkProps from "shared/link-props"
import memo from "set-state-compare/src/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default memo(shapeComponent(class ComponentsDialogues extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {columns, editModelPath, viewModelPath} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--dialogues--table", className)}
        columns={columns}
        editModelPath={editModelPath}
        modelClass={Dialogue}
        preloads={["contact"]}
        select={{
          Contact: ["id", "name"],
          Dialogue: ["id", "translatedDialogueType"]
        }}
        viewModelPath={viewModelPath}
        {...restProps}
      />
    )
  }

  columns = () => [
    {
      attribute: "id",
      defaultVisible: false,
      sortKey: "id"
    },
    {
      content: this.tt.dialogueContent,
      label: Dialogue.modelName().human(),
      sortKey: "currentTranslationName"
    },
    {
      content: this.tt.contactContent,
      label: Dialogue.humanAttributeName("contact"),
      sortKey: "contactFirstName"
    },
    {
      attribute: "dialogueType",
      content: this.tt.dialogueTypeContent,
      sortKey: "dialogueType"
    }
  ]

  editModelPath = ({dialogue}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.editAdminDialoguePath(dialogue.id())
  }

  viewModelPath = ({dialogue}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.adminDialoguePath(dialogue.id())
  }

  dialogueContent = ({dialogue}) => <DialogueLink dialogue={dialogue} {...linkProps(this.props)} />
  dialogueTypeContent = ({dialogue}) => dialogue.translatedDialogueType()
  contactContent = ({dialogue}) => dialogue.contact() && <ContactLink contact={dialogue.contact()} {...linkProps(this.props)} />
}))
